<template>
  <div
    class="content-devx content-dx-upload-file"
  >
    <f7-block class="profile">
      <input
        id="upload"
        type="file"
        accept="image/png, image/gif, image/jpeg, application/pdf"
        @change="onFileSelected"
      >
    </f7-block>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'UploadFile',

  props: {
    urlToSend: { type: String, default: 'crop/file/up' },
  },
  data() {
    return {
      selectedFile: '',
    };
  },
  computed: {
    ...mapState('SearcherObservations', ['fileDescription']),
  },
  methods: {
    onFileSelected(event) {
      const reader = new FileReader();
      const newFile = event.target.files[0];

      reader.onload = (e) => {
        this.selectedFile = `${e.target.result}`;
        this.setAttachment(this.selectedFile);
      };
      reader.onerror = (error) => {
        this.$f7.dialog.alert(`${this.$t('UploadFile_error')} ${error}`);
      };
      reader.readAsDataURL(newFile);
    },
    ...mapActions('Nutrition', ['setAttachment']),

  },
};
</script>
